<ng-container
	[ngSwitch]="jurisdiction$ | async"
	*ngIf="(isRegulatoryBarEnabled$ | async) && ((isAuthenticated$ | async) || (isEnabledForLoggedOut$ | async))"
>
	<ng-container *ngSwitchCase="ksaJurisdiction">
		<obg-ksa-regulatory-bar></obg-ksa-regulatory-bar>
	</ng-container>

	<ng-container *ngSwitchCase="aamsJurisdiction">
		<obg-aams-regulatory-bar *ngIf="isAamsRegulatoryBarEnabled$ | async"> </obg-aams-regulatory-bar>

		<obg-aams-session-info-bar
			*ngIf="inGame && (isAuthenticated$ | async)"
			[game]="game"
			[gameHistoryEnabled]="gameHistoryEnabled"
		>
		</obg-aams-session-info-bar>

		<obg-aams-game-regulatory-bar
			*ngIf="(isAuthenticated$ | async) && (shouldShowAamsSession$ | async) && (aamsGameData?.activeGame || {} | keyvalue).length"
			[aamsGameData]="aamsGameData"
		>
		</obg-aams-game-regulatory-bar>
	</ng-container>

	<ng-container *ngSwitchCase="cogaJurisdiction">
		<obg-session-timer-regulatory-bar></obg-session-timer-regulatory-bar>
	</ng-container>

	<ng-container *ngSwitchCase="braJurisdiction">
		<obg-session-timer-regulatory-bar></obg-session-timer-regulatory-bar>
	</ng-container>

	<ng-container *ngSwitchDefault>
		<obg-standard-regulatory-bar></obg-standard-regulatory-bar>
	</ng-container>
</ng-container>
